<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='" background-image: url(\"https:\/\/api.tabibekhanevade.ir\/storage\/mezaj\/pngtree-herbal-plants-cosmetic-natural-plant-png-image_4904305.png\");"' class="h-100 bg-primary" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="pt-5 " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container text-center bg-white p-5 rounded " >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='"\n  background: -webkit-linear-gradient(#23A9B3, #03045e);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;"' class="text-center my-5" >
                <template #default>مزاج شما گرم و تر (دموی)است.   </template>
                </m-h1><m-audio v-bind='{...{"audio":"https:\/\/api.tabibekhanevade.ir\/storage\/mezaj\/damavi.mp3"},...{}}' :style='""' class="col-8 my-4" ></m-audio><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>ویژگیهای ذیل مربوط به مزاج سرشتی افراد دموی می باشد.

این افراد هیکل درشت و بدنی عضلانی دارند و لاغر نیستند. پوستی سرخ و سفید رنگ دارند. موهای پر پشت دارند، نبض پر و قوی دارند. خوب می خوابند و تحمل بی خوابی را نیز دارند. پوست اینها گرم و مرطوب و نرم است. نه گرمایی هستند و نه سرمایی، اما به نسبت تحمل سرما برایشان راحت تر است. میل به شیرینی و ترشی دارند. همه نوع غذا را می توانند بخورند.
این افراد انسانهای شجاع و جسور هستند با اعتماد به نفس بالا. معمولاً مدیر و رهبر یک گروه یا یک جمع می باشند و خوش اخلاق، صمیمی، خوشرو و آرام هستند اما اگر عصبانی شوند، رفتارهای مخاطره آمیز از خود نشان
می دهند. معمولاً اهل ریسک کردن هستند. به اندازه صفراوی مزاج ها منظم ودقیق نیستند، اکثراً بی نظم هستند، هوش و حافظه بالایی دارند. سریع و پر انرژی هستند. میل و توان جنسی بالایی دارند استعداد ابتلا به بیماریهای قلبی و عروقی و فشار خون بالا دارند. عروق روی دست ها برجسته است نبض آنان پر و قوی است.
قدرت حرکات بدنی آنها بالاست و صدایی رسا و محکم دارند. قدرت هضم و اشتهایشان خوب است و معمولاً یبوست ندارند.
دموی ها معمولاً افرادی بی خیال و سرزنده و اغلب بی حساب و کتاب اند.
توصیه و تدابیر:
افراد دموی بايد غذاهای خنک و سردی مثل آش انار، آش آلو، آب زرشك، خيار، مركبات و ماست مصرف كنند تا حرارت بدن تعديل شود.
اگر فرد دموی همراه با غذای گرم مثل شيرينی‌جات از مواد و اغذيه سرد استفاده نكند دچار جوش و خارش بدن، گر گرفتگی، بيقراری، كهير، سوزش ادرار، سوزش سر دل و آفت دهان خواهد شد.
معمولاً بيماریهای افراد دموی در اثر افزايش حرارت و رطوبت و به طور كلی افزايش خون به وجود مي‌آيد كه حجامت به عنون مؤثرترين درمان براي دموی مزاج‌ها مطرح است. چون دم گرم‌ و تر است، رژيم غذایی مناسب براي دموی‌ها رژيم غذايی سرد و خشک است.
علایم غلبه خلط دم:
اگر تعادل میان اخلاط و مقدار آنها یا کیفیت هر یک از اخلاط بهم بخورد، موجب بیماری در بدن می شود یا به عبارتی موجب غلبه یک خلط بر اخلاط دیگر در بدن می شود که می بایست مورد درمان قرار گیرد که در ذیل علایم غلبه خلط دم ذکر شده است.
•    پری رگها و پری نبض
•    سر درد و احساس سنگینی سر
•    سرخی چشم ها در صورت و بدن
•    ایجاد دمل و جوش و بثورات پوستی و خارش (بیشتر در تنه وکتف)
•    زیاد شدن خواب
•    احساس کسالت و خمیازه
•    احساس مزه شیرین در دهان
•     خون ریزی لثه وبینی
•    خارش محل حجامت وفصد قبلی
•    افزایش فشار خون   </template>
                </m-p></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mAudio from '@moeinmdn/miw-alpha-components/src/package/Tags/Audio'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mAudio,mP },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
